import React, { useCallback, useMemo } from "react";
import { StyledAppHeader } from "./index.styled";
import { Flex } from "antd";
import { LuMenu } from "react-icons/lu";
import { useCommon, useKYCStatus, useMainStore } from "_hooks";
import { useLocation } from "react-router-dom";
import { ADD_FUNDS_ROUTE, HOME_ROUTE, KYC_ROUTE } from "_constants";
import AppLogo from "_lib/AppLogo";
import AppAvatar from "_lib/AppAvatar";
import ContainerButton from "_lib/ContainerButton";
import { MdOutlineAddCircle } from "react-icons/md";
import { BiSolidFaceMask } from "react-icons/bi";

const AppHeader = () => {
  const { setMobileMenuOpen } = useMainStore();
  const { isVerified } = useKYCStatus();
  const { onRedirect } = useCommon();
  const { pathname } = useLocation();

  const onClickMenu = useCallback(() => {
    setMobileMenuOpen(true);
  }, [setMobileMenuOpen]);

  const buttonProps = useMemo(() => {
    let currentButtonProps = {
      title: "Verify ID",
      path: KYC_ROUTE,
      show: pathname !== KYC_ROUTE,
      icon: <BiSolidFaceMask />,
    };
    if (isVerified) {
      currentButtonProps.path = ADD_FUNDS_ROUTE;
      currentButtonProps.title = "Deposit";
      currentButtonProps.show = pathname !== ADD_FUNDS_ROUTE;
      currentButtonProps.icon = <MdOutlineAddCircle />;
    }
    currentButtonProps.onClick = onRedirect(currentButtonProps.path);
    return currentButtonProps;
  }, [isVerified, onRedirect, pathname]);

  return (
    <StyledAppHeader>
      <Flex align="center" justify="space-between" gap={8}>
        <LuMenu className="menu-icon" size={22} onClick={onClickMenu} />
        <AppLogo short height={26} onClick={onRedirect(HOME_ROUTE)} />
      </Flex>
      <Flex gap={8} align="center">
        {buttonProps?.show && (
          <ContainerButton type="primary" size="middle" {...buttonProps} />
        )}
        <AppAvatar />
      </Flex>
    </StyledAppHeader>
  );
};

export default AppHeader;
